function waitForValidJWT() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      const jwt = getCookie('jwt');
      if (jwt && jwt !== 'false') {
        clearInterval(interval);
        resolve(jwt);
      }
    }, 100); 
  });
}

document.addEventListener('DOMContentLoaded', async function() {
  let hasChangeReminder = false;

  // Helper function to handle element selection
  const select = (selector, context = document) => context.querySelector(selector);
  const selectAll = (selector, context = document) => Array.from(context.querySelectorAll(selector));

  // Function to open or close popups
  const openPopup = (element, selector, toggleClass) => {
    const popup = select(selector, element.closest('.reminders-main'));
    popup.classList.add('active');
    if (toggleClass) popup.classList.remove(toggleClass);
    document.body.classList.add('dialog-open');
  };

  const closePopup = (element) => {
    element.closest('.close-popup').classList.remove('active');
    document.body.classList.remove('dialog-open');
  };

  // Handle click events on body for popup dialogs
  document.body.addEventListener('click', function(e) {
    if (document.body.classList.contains('dialog-open')) {
      if (e.target.closest('.delete-reminder-contain') || 
        e.target.closest('.reminder-popup-container') || 
        e.target.closest('button') || 
        e.target.closest('.edit-icon') || 
        e.target.closest('.delete-icon') || 
        e.target.closest('.diolog-discard-contain') || 
        e.target.closest('.reminder-popup-container-main')) {
        return false;
      }  
       if (hasChangeReminder) {
        const discardDialog = select('.reminders-main .diolog-discard-main');
        if (discardDialog) {
          discardDialog.classList.toggle('active');
        }        
      } else {
        selectAll('.reminders-main .close-popup').forEach(popup => {
          popup.classList.remove('active');
        });
        document.body.classList.remove('dialog-open');
      }
    }
  });
  
  window.reCallEventFun = function() {
    selectAll('.reminders-main .delete-icon').forEach(el => {
      el.onclick = function() {
        const parents = this.closest('.reminders-main');
        const deleteReminderMain = select('.delete-reminder-main', parents);
        
        const reminderId = this.closest('.reminder-card-top').getAttribute('data-id');
        select('#confirm-delete', parents).value = reminderId;

        if (deleteReminderMain) {
          deleteReminderMain.classList.add('active');
          document.body.classList.add('dialog-open');
        }
      };
    });

    selectAll('.reminders-main .confirm-delete').forEach(el => {
      el.onclick = function() {
        const deleteReminder = this.closest('.delete-reminder-main');
        window.deleteReminder(deleteReminder);
      };
    });
  
    // Open and reset specific popups
    selectAll('.reminders-main .discard-popup').forEach(el => {
      el.onclick = function() {
        selectAll('.reminders-main .close-popup').forEach(popup => popup.classList.remove('active'));
        document.body.classList.remove('dialog-open');
        window.clearReminderFormData();
        hasChangeReminder = false;
      };
    });
    
    selectAll('.reminders-main .create-reminder').forEach(el => {
      el.onclick = function() {
        window.clearReminderFormData();
        openPopup(this, '.create-reminder-popup-main', 'edit-reminder');
      };
    });

    selectAll('.reminders-main button.continue').forEach(el => {
      el.onclick = function() {
        const createReminder = this.closest('.create-reminder-popup-main');
        window.createReminder(createReminder);
        hasChangeReminder = false;
      };
    });

    selectAll('.reminders-main .update-reminder').forEach(el => {
      el.onclick = function() {
        const loaderElement = select('.reminders-main .reminder-loader-main');
        const upcomingElement = select('.reminders-main .upcoming-reminder-main');
        
        if (loaderElement) loaderElement.classList.add('active');
        if (upcomingElement) upcomingElement.classList.add('hidden');
        
        const editReminder = this.closest('.edit-reminder');
        editReminder.classList.remove('active');
        document.body.classList.remove('dialog-open');
        window.updateReminder(editReminder);
      };
    });
  
    selectAll('.reminders-main .reminder-settings').forEach(el => {
      el.onclick = function() {
        openPopup(this, '.reminder-settings-popup-main');
      };
    });
  
    selectAll('.reminders-main .close-btn, .reminders-main .notification-done').forEach(el => {
      el.onclick = function() {
        const isDelete = document.querySelector('.delete-reminder-main.active')?.length;
        if (isDelete && isDelete > 0) {
          if (hasChangeReminder) {
            openPopup(this, '.diolog-discard-main');
            return;
          }
        }
        closePopup(this);
      };
    });
    
  
    selectAll('.reminders-main .edit-icon').forEach(el => {
      el.onclick = function() {
        const parents = this.closest('.reminders-main');
        const popup = select('.create-reminder-popup-main', parents);
        
        popup.classList.add('active', 'edit-reminder');
        document.body.classList.add('dialog-open');
    
        const thisCard = this.closest('.reminder-card-top');
        const eventId = thisCard.getAttribute('data-id');
        const eventMonth = thisCard.getAttribute('event-month');
        const eventDay = thisCard.getAttribute('event-day');
        const dataOccasion = thisCard.getAttribute('data-occasion');
        const dataRelationship = thisCard.getAttribute('data-relationship');
        const dataRecipient = thisCard.getAttribute('data-recipient');
        const dataOccasionText = thisCard.getAttribute('data-occasion-text');
        const dataRelationshipText = thisCard.getAttribute('data-relationship-text');
    
        updateDays(eventMonth, select('#event-day', parents));
    
        // Update form fields
        const selectOccasion = document.getElementById('occasion');
        let classAdded = false;        
        for (let option of selectOccasion.options) {
          if (option.getAttribute('data-month') !== "0" && option.value === dataOccasion) {
            select('.reminders-date', parents).classList.add('disabled');
            classAdded = true;
            break;
          }
        }
        if (!classAdded) {
          select('.reminders-date', parents).classList.remove('disabled');
        }
        
        select('#data-id', parents).value = eventId;
        select('#occasion', parents).value = dataOccasion;
        select('#event-month', parents).value = eventMonth;
        select('#event-day', parents).value = eventDay;
        select('#recipient', parents).value = dataRelationship;
        select('#nickname', parents).value = dataRecipient;

        if(dataRelationship != 'Other Relationship'){
          select('#recipient-text').closest('.form-wrap').classList.add('hidden');
        }else{
          select('#recipient-text').closest('.form-wrap').classList.remove('hidden');
          select('#recipient-text', parents).value = dataRelationshipText;
        }

        if(dataOccasion != 'Other Occasion'){
          select('#occasion-text').closest('.form-wrap').classList.add('hidden');
        }else{
          select('#occasion-text').closest('.form-wrap').classList.remove('hidden');
          select('#occasion-text', parents).value = dataOccasionText;
        }

        // Trigger change for occasion and recipient
        validateAndCountErrors(select('#occasion', parents));
        validateAndCountErrors(select('#recipient', parents));
        
        hasChangeReminder = false;
      };
    });
    
    // Handle input events for both main reminder and product reminder contexts
    const contexts = ['.reminders-main', '.product-reminder-compact'];
    contexts.forEach(context => {
      selectAll(`${context} .input-text-field`).forEach(input => {
        input.addEventListener('keypress', function() {
          window.fieldValidation(this);
          window.onlyErrCount();
        });
      
        input.addEventListener('keyup', function() {
          window.fieldValidation(this);
          window.onlyErrCount();
        });
      
        input.addEventListener('keydown', function() {
          window.fieldValidation(this);
          window.onlyErrCount();
        });
      });
    });

    // Handle global modal input events separately
    selectAll('#global-reminder-modal .input-text-field').forEach(input => {
      input.addEventListener('keypress', function() {
        window.fieldValidation(this);
        window.onlyErrCount();
      });
    
      input.addEventListener('keyup', function() {
        window.fieldValidation(this);
        window.onlyErrCount();
      });
    
      input.addEventListener('keydown', function() {
        window.fieldValidation(this);
        window.onlyErrCount();
      });
    });
  
    selectAll('.reminders-main .discard-dialog').forEach(element => {
      element.onclick = function() {
        const closePopup = this.closest('.close-popup');
        if (closePopup) {
          closePopup.classList.remove('active');
        }
      };
    });
    
    // Update days in the dropdown based on the selected month - for both contexts
    contexts.forEach(context => {
      const monthSelect = select(`${context} #event-month`);
      if (monthSelect) {
        monthSelect.addEventListener('change', function() {
          const selectedMonth = this.value;
          const daySelect = select('#event-day', this.closest(context));
          if (daySelect) {
            selectedMonth ? updateDays(selectedMonth, daySelect) : resetDaySelect(daySelect);
          }
          validateAndCountErrors(this);
        });
      }
    });

    // Handle global modal month change separately
    const globalMonthSelect = select('#global-event-month');
    if (globalMonthSelect) {
      globalMonthSelect.addEventListener('change', function() {
        const selectedMonth = this.value;
        const daySelect = select('#global-event-day');
        if (daySelect) {
          selectedMonth ? updateDays(selectedMonth, daySelect) : resetDaySelect(daySelect);
        }
        validateAndCountErrors(this);
      });
    }
  
    // Handle the change of occasion and update the UI accordingly - for both contexts
    contexts.forEach(context => {
      const occasionSelect = select(`${context} #occasion`);
      if (occasionSelect) {
                 occasionSelect.addEventListener('change', function() {
            const parents = this.closest(context) || this.closest('.reminders-main');
            const dateContainer = select('.reminders-date', this.closest('.reminder-popup-container'));

      if(this.value === 'Other Occasion') {
        this.closest(".reminder-popup-container").querySelector(".occasion-text #occasion-text").value = '';
        this.closest(".reminder-popup-container").querySelector(".occasion-text").classList.remove("hidden");
      }else{
        this.closest(".reminder-popup-container").querySelector(".occasion-text").classList.add("hidden");
      }
  
      const selectedOption = this.options[this.selectedIndex];
      const month = selectedOption.getAttribute('data-month');
      const day = selectedOption.getAttribute('data-day');

      if (month != 0 && day != 0) {
        select('#event-month', parents).value = month;
        updateDays(month, select('#event-day', parents));
        select('#event-day', parents).value = day;
        dateContainer.classList.add('disabled');
      } else {
        const monthSelect = select('#event-month', parents);
        const daySelect = select('#event-day', parents);
        if (monthSelect) {
          monthSelect.value = '';
        }
        if (daySelect) {
          daySelect.innerHTML = '';
        }
        dateContainer.classList.remove('disabled');
      }
  
        validateAndCountErrors(this);
        });
      }
    });

    // Handle global modal occasion change separately
    const globalOccasionSelect = select('#global-occasion');
    if (globalOccasionSelect) {
      globalOccasionSelect.addEventListener('change', function() {
        const globalModal = this.closest('#global-reminder-modal');
        const dateContainer = select('.reminders-date', globalModal);

        if(this.value === 'Other Occasion') {
          globalModal.querySelector(".occasion-text #global-occasion-text").value = '';
          globalModal.querySelector(".occasion-text").classList.remove("hidden");
        } else {
          globalModal.querySelector(".occasion-text").classList.add("hidden");
        }

        const selectedOption = this.options[this.selectedIndex];
        const month = selectedOption.getAttribute('data-month');
        const day = selectedOption.getAttribute('data-day');

        if (month != 0 && day != 0) {
          select('#global-event-month', globalModal).value = month;
          updateDays(month, select('#global-event-day', globalModal));
          select('#global-event-day', globalModal).value = day;
          dateContainer.classList.add('disabled');
        } else {
          const monthSelect = select('#global-event-month', globalModal);
          const daySelect = select('#global-event-day', globalModal);
          if (monthSelect) {
            monthSelect.value = '';
          }
          if (daySelect) {
            daySelect.innerHTML = '';
          }
          dateContainer.classList.remove('disabled');
        }

        validateAndCountErrors(this);
      });
    }
  
    // Handle dropdown events for both contexts
    contexts.forEach(context => {
      selectAll(`${context} #recipient, ${context} #event-day`).forEach(element => {
        element.addEventListener('change', function() {
          if(this.value === 'Other Relationship') {
            const recipientTextElement = this.closest(".reminder-popup-container").querySelector(".recipient-text #recipient-text");
            const recipientTextContainer = this.closest(".reminder-popup-container").querySelector(".recipient-text");
            if (recipientTextElement) recipientTextElement.value = '';
            if (recipientTextContainer) recipientTextContainer.classList.remove("hidden");
          } else {
            const recipientTextContainer = this.closest(".reminder-popup-container").querySelector(".recipient-text");
            if (recipientTextContainer) recipientTextContainer.classList.add("hidden");
          }
          window.dropdownSelectValidation(this);
          window.onlyErrCount();
        });
      });
    });

    // Handle global modal dropdown events separately
    selectAll('#global-recipient, #global-event-day').forEach(element => {
      element.addEventListener('change', function() {
        if(this.value === 'Other Relationship') {
          const globalModal = this.closest('#global-reminder-modal');
          const recipientTextElement = globalModal.querySelector(".recipient-text #global-recipient-text");
          const recipientTextContainer = globalModal.querySelector(".recipient-text");
          if (recipientTextElement) recipientTextElement.value = '';
          if (recipientTextContainer) recipientTextContainer.classList.remove("hidden");
        } else {
          const globalModal = this.closest('#global-reminder-modal');
          const recipientTextContainer = globalModal.querySelector(".recipient-text");
          if (recipientTextContainer) recipientTextContainer.classList.add("hidden");
        }
        window.dropdownSelectValidation(this);
        window.onlyErrCount();
      });
    });
  }
  
  // Utility functions
  function updateDays(month, daySelect) {
    const daysInMonth = getDaysInMonth(month);
    daySelect.innerHTML = '<option value=""></option>';
    for (let i = 1; i <= daysInMonth; i++) {
      const option = document.createElement('option');
      option.value = i;
      option.textContent = i;
      daySelect.appendChild(option);
    }
  }

  function resetDaySelect(daySelect) {
    daySelect.innerHTML = '<option value=""></option>';
  }

  function getDaysInMonth(month, year = new Date().getFullYear()) {
    if (month === '2') return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0) ? 29 : 28;
    return ['4', '6', '9', '11'].includes(month) ? 30 : 31;
  }

  function validateAndCountErrors(element) {
    window.dropdownSelectValidation(element);
    window.onlyErrCount();
  }

  window.onlyErrCount = function() {
    hasChangeReminder = true;
    let errorCount = 0;
  
    // Get all text fields and check for errors in all contexts
    const contexts = ['.reminders-main', '.product-reminder-compact', '#global-reminder-modal'];
    const passwordMaxLength = 50;
  
    contexts.forEach(context => {
      const inputTextFields = selectAll(`${context} .input-text-field`);
      inputTextFields.forEach(input => {
        const value = input.value.trim();
        if (value === '' || value.length > passwordMaxLength) {
          errorCount++;
        }
      });
  
      // Check all select fields for errors
      const inputSelectFields = selectAll(`${context} .input-select-field`);
      inputSelectFields.forEach(select => {
        if (select.value === '') {
          errorCount++;
        }
      });
    });
    
    return errorCount;
  };

  window.fieldValidation = function(inputElement) {
    let errorCount = 0;
    const parent = inputElement.closest('.form-wrap');
    const passwordMaxLength = 50;
    const errorElement = select('.form-error', parent);
  
    const value = inputElement.value.trim();
  
    if(errorElement){
      if (value === '') {
        errorElement.classList.add('active');
        parent.classList.add('error-active');
        errorCount = 1;
      } else if (value.length > passwordMaxLength) {
        errorElement.textContent = 'Please shorten to ' + passwordMaxLength + ' characters or less.';
        errorElement.classList.add('active');
        errorCount = 1;
      } else {
        errorElement.classList.remove('active');
        parent.classList.remove('error-active');
        errorCount = 0;
      }
    }

    // Handle button state for different contexts
    const isGlobalModal = inputElement.closest('#global-reminder-modal');
    if (isGlobalModal) {
      const createButton = isGlobalModal.querySelector('.global-create-reminder');
      if(createButton) {
        if(errorCount > 0) {
          createButton.disabled = true;
        } else {
          createButton.disabled = false;
        }
      }
    } else {
      const updateReminder = select('.reminders-main .update-reminder');
      if(updateReminder) {
        if(errorCount > 0) {
          updateReminder.disabled = true;
        } else {
          updateReminder.disabled = false;
        }
      }
    }
  
    return errorCount;
  };

  window.dropdownSelectValidation = function(selectElement) {
    let errorCount = 0;
  
    const formWrap = selectElement.closest('.form-wrap');
    const errorElement = select('.form-error', formWrap);
  
    if (selectElement.value === '') {
      errorElement.classList.add('active');
      formWrap.classList.add('error-active');
      errorCount = 1;
    } else {
      errorElement.classList.remove('active');
      formWrap.classList.remove('error-active');
      errorCount = 0;
    }

    return errorCount;
  };
  
  window.clearReminderFormData = function() {
    // Clear fields in all contexts
    const contexts = ['.reminders-main', '.product-reminder-compact', '#global-reminder-modal'];
    
    contexts.forEach(context => {
      selectAll(`${context} .input-text-field, ${context} .input-select-field`).forEach(field => field.value = '');
      selectAll(`${context} .form-error`).forEach(error => error.classList.remove('active'));
      selectAll(`${context} .form-wrap`).forEach(form => form.classList.remove('error-active'));
    });
    
    // Hide conditional fields (try all contexts)
    const recipientTexts = [
      select('.recipient-text'),
      select('.product-reminder-compact .recipient-text'),
      select('#global-reminder-modal .recipient-text')
    ].filter(el => el !== null);
    
    const occasionTexts = [
      select('.occasion-text'),
      select('.product-reminder-compact .occasion-text'),
      select('#global-reminder-modal .occasion-text')
    ].filter(el => el !== null);
    
    recipientTexts.forEach(el => el.classList.add('hidden'));
    occasionTexts.forEach(el => el.classList.add('hidden'));
  };

  const jwt = await waitForValidJWT();
  const accountId = getCookie('accountId');

  const myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${jwt}`);
  const remindersApi = `${window.reminders.baseUrl}/${accountId}/reminder`;

  window.fetchReminder = function(){
    // Check if we're in product context or if required elements exist
    if (window.isProductReminderContext) {
      return;
    }
    
    const loaderElement = select('.reminders-main .reminder-loader-main');
    const upcomingElement = select('.reminders-main .upcoming-reminder-main');
    
    if (!loaderElement || !upcomingElement) {
      console.warn('Required reminder elements not found. Skipping fetchReminder.');
      return;
    }
    
    loaderElement.classList.add('active');
    upcomingElement.classList.add('hidden');
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };
  
    fetch(`${remindersApi}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let response = JSON.parse(result);
        if(response.meta.code == 200){
          if(response.data.length == 0){
            select('.reminders-main .reminders-listing').classList.remove('hidden');
            select('.reminders-main .upcoming-reminder-main').classList.add('hidden');
            select('.reminders-main .reminder-loader-main').classList.remove('active');
            return false;
          }else{
            select('.reminders-main .reminders-listing').classList.add('hidden');
          }
          let reminderCardHtml = '';
          for(let i=0; i<response.data.length; i++){
            let month = response.data[i].month;
            let day = response.data[i].day;
            let occasion = response.data[i].occasion;
            let relationship = response.data[i].relationship;
            let occasionText = response.data[i].occasion_text;
            let relationshipText = response.data[i].relationship_text;
            let recipient = response.data[i].recipient;
            let id = response.data[i].id;
    
            const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JULY", "AUG", "SEP", "OCT", "NOV", "DEC"];
            let occasionSettings = window.shopCard.find(block => 
              block.occasion.toLowerCase() === response.data[i].occasion.toLowerCase()
            );
  
            if (!occasionSettings) {
              occasionSettings = window.shopCard.find(block => block.occasion.toLowerCase() === 'default');
            }
  
            let buttonLabel = occasionSettings ? occasionSettings.button_label : 'Shop All';
            let buttonURL = occasionSettings ? occasionSettings.button_url : '/collections/all';
  
            reminderCardHtml += `
              <div class="reminder-card">
                <div class="reminder-card-top" data-id="${id}" event-month="${month}" event-day="${day}" data-occasion="${occasion}" data-relationship="${relationship}" data-recipient="${recipient}" data-relationship-text="${relationshipText}" data-occasion-text="${occasionText}">
                  <div class="date-main">
                    <span class="date-icon">
                      <svg version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 682.667 682.667" style="enable-background:new 0 0 512 512" xml:space="preserve">
                        <g>
                          <defs>
                            <clipPath clipPathUnits="userSpaceOnUse">
                              <path d="M0 512h512V0H0Z" fill="#000000" opacity="1" data-original="#000000"></path>
                            </clipPath>
                          </defs>
                          <g clip-path="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
                            <path d="M0 0h39.333m78.895 0h39.333M-118 0h39.333M0 118h39.333m78.895 0h39.333M-118 118h39.333m-137.666 98.667h472.227M-137.439-98H177c43.572 0 78.894 35.322 78.894 78.895v274.877c0 43.572-35.322 78.895-78.894 78.895h-314.439c-43.572 0-78.894-35.323-78.894-78.895V-19.105c0-43.573 35.322-78.895 78.894-78.895zm275.333 373.667V374m-236.227-98.333V374" style="stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(236.333 118)" fill="none" stroke="#000000" stroke-width="40" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class=""></path>
                          </g>
                        </g>
                      </svg>
                    </span>
                    <p class="date-text">${monthNames[month - 1]} ${day}</p>
                  </div>
                  <span class="edit-icon">
                    <svg version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 682.667 682.667" style="enable-background:new 0 0 512 512" xml:space="preserve">
                      <g>
                        <defs>
                          <clipPath clipPathUnits="userSpaceOnUse">
                            <path d="M0 512h512V0H0Z" fill="#000000" opacity="1" data-original="#000000"></path>
                          </clipPath>
                        </defs>
                        <g clip-path="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
                          <path d="m0 0-63.636 63.636c-11.684 11.685-30.737 11.693-42.411.018l-324.455-324.455 106.065-106.066L.019-42.412C11.693-30.737 11.685-11.685 0 0Z" style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1" transform="translate(488.08 424.444)" fill="none" stroke="#000000" stroke-width="30" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="22.926" stroke-dasharray="none" stroke-opacity="" data-original="#000000"></path>
                          <path d="m0 0 42.427 148.492L148.492 42.427Z" style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1" transform="translate(15.15 15.15)" fill="none" stroke="#000000" stroke-width="30" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="22.926" stroke-dasharray="none" stroke-opacity="" data-original="#000000"></path>
                          <path d="m0 0-106.066 106.066" style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1" transform="translate(445.656 339.59)" fill="none" stroke="#000000" stroke-width="30" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="22.926" stroke-dasharray="none" stroke-opacity="" data-original="#000000"></path>
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span class="delete-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x" aria-hidden="true">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </span>
                </div>
                <div class="reminder-detail">
                  <p>${recipient} - ${occasion}</p>
                </div>
                <a class="button shop-card-btn" href="${buttonURL}" target="_blank">${buttonLabel}</a>
              </div>`;
          }
          const reminderCardMain = select('.reminder-card-main');
          if (reminderCardMain) {
            reminderCardMain.innerHTML = '';
            reminderCardMain.insertAdjacentHTML('beforeend', reminderCardHtml);
            window.reCallEventFun();
            select('.reminders-main .reminder-loader-main').classList.remove('active');
            select('.reminders-main .upcoming-reminder-main').classList.remove('hidden');
          }
        }
      })
      .catch((error) => console.error(error));
  }
  // Only fetch reminders if we're in the main reminder page context
  setTimeout(() => {
    if (!window.isProductReminderContext && window.fetchReminder) {
      window.fetchReminder();
    }
  }, 2000);

  window.updateReminder = function(editReminder){
    const eventId = editReminder.querySelector('#data-id').value;
    const nickname = editReminder.querySelector('#nickname').value;
    const recipient = editReminder.querySelector('#recipient').value;
    const occasion = editReminder.querySelector('#occasion').value;
    const eventMonth = Number(editReminder.querySelector('#event-month').value);
    const eventDay = Number(editReminder.querySelector('#event-day').value);
    const relationshipText = editReminder.querySelector('#recipient-text').value;
    const occasionText = editReminder.querySelector('#occasion-text').value;
    
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
      "id": eventId,
      "recipient": nickname,
      "relationship": recipient,
      "relationship_text": relationshipText,
      "occasion": occasion,
      "occasion_text": occasionText,
      "month": eventMonth,
      "day": eventDay
    });
    
    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };
    
    fetch(`${remindersApi}/${eventId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let response = JSON.parse(result);
        if(response.meta.code == 200){
          if (window.fetchReminder && !window.isProductReminderContext) {
            window.fetchReminder();
          }
        }
      })
      .catch((error) => console.error(error));
  }

  // Function to open global reminder modal from hero section
  window.openGlobalReminderModal = function() {
    const modal = document.getElementById('global-reminder-modal');
    if (modal) {
      // Clear the form first
      window.clearReminderFormData();
      
      // Clear product-specific content (since this is general use, not product-specific)
      const productNameSpan = modal.querySelector('.product-name');
      const productIdInput = modal.querySelector('#global-product-id');
      if (productNameSpan) productNameSpan.textContent = '';
      if (productIdInput) productIdInput.value = '';
      
      // Show modal
      modal.style.display = 'flex';
      document.body.classList.add('dialog-open');
    } else {
      console.error('Global reminder modal not found');
    }
  };

  window.createReminder = function(createReminder){
    
    // Check if this is the global modal (collection context)
    const isGlobalModal = createReminder && createReminder.id === 'global-reminder-modal';
    
    // Select required fields - use global IDs for global modal
    const recipient = createReminder.querySelector(isGlobalModal ? '#global-nickname' : '#nickname');
    const relationship = createReminder.querySelector(isGlobalModal ? '#global-recipient' : '#recipient');
    const occasion = createReminder.querySelector(isGlobalModal ? '#global-occasion' : '#occasion');
    const eventMonth = createReminder.querySelector(isGlobalModal ? '#global-event-month' : '#event-month');
    const eventDay = createReminder.querySelector(isGlobalModal ? '#global-event-day' : '#event-day');
    const relationshipText = createReminder.querySelector(isGlobalModal ? '.recipient-text:not(.hidden) #global-recipient-text' : '.recipient-text:not(.hidden) #recipient-text');
    const occasionText = createReminder.querySelector(isGlobalModal ? '.occasion-text:not(.hidden) #global-occasion-text' : '.occasion-text:not(.hidden) #occasion-text');
    let relationshipTextValue = '';
    if(relationshipText){
      relationshipTextValue = relationshipText.value;
    }else{
      relationshipTextValue = '';
    }
    let occasionTextValue = '';
    if(occasionText){
      occasionTextValue = occasionText.value;
    }else{
      occasionTextValue = '';
    }
  
    // Check if any required field is empty
    let hasError = false;
    
    const fields = [recipient, relationship, occasion, eventMonth, eventDay];
    fields.forEach(field => {
        if (!field || !field.value || field.value.trim() === '') {
          hasError = true;
          
          // Show visual error feedback
          if (field) {
            if (field.tagName === 'SELECT') {
              window.dropdownSelectValidation(field);
            } else {
              window.fieldValidation(field);
            }
          }
        }
    });

    // Prevent submission if there are validation errors
    if (hasError) {
      return;
    }
    
    // Proceed with reminder creation if no errors
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
      "recipient": recipient.value,
      "relationship": relationship.value,
      "occasion": occasion.value,
      "month": Number(eventMonth.value),
      "day": Number(eventDay.value),
      "relationship_text": relationshipTextValue,
      "occasion_text": occasionTextValue
    });
  
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };
  
    fetch(`${remindersApi}`, requestOptions)
      .then((response) => {
        return response.text();
      })
      .then((result) => {
        let response = JSON.parse(result);
        if(response.meta.code == 201){
          // Tag customer with "reminder-customer" tag
          window.tagReminderCustomer();
          
          if (isGlobalModal) {
            // Close global modal
            createReminder.style.display = 'none';
            document.body.classList.remove('dialog-open');
            
            // Show discount modal if enabled
            setTimeout(() => {
              if (window.showDiscountModal && document.getElementById('reminder-discount-modal')) {
                window.showDiscountModal();
              }
            }, 300);
          } else {
            // Original behavior for main reminder section
            createReminder.classList.remove('active');
            document.body.classList.remove('dialog-open');
            
            // Show discount modal if enabled
            setTimeout(() => {
              if (window.showDiscountModal && document.getElementById('reminder-discount-modal')) {
                window.showDiscountModal();
              }
            }, 300);
            
            if (window.fetchReminder && !window.isProductReminderContext) {
              window.fetchReminder();
            }
          }
        } else {
          console.error('API returned error:', response);
        }
      })
      .catch((error) => {
        console.error('API request failed:', error);
      });
  }
  
  window.deleteReminder = function(deleteReminder){
    let deleteReminderId = deleteReminder.querySelector('#confirm-delete').value;
    
    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(`${remindersApi}/${deleteReminderId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (window.fetchReminder && !window.isProductReminderContext) {
          window.fetchReminder();
        }
        deleteReminder.classList.remove('active');
        document.body.classList.remove('dialog-open');
      })
      .catch((error) => console.error(error));
  }

  window.occasionsFetch = function(){
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(`${window.reminders.baseUrl}/occasions`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      let response = JSON.parse(result);
      if(response.meta.code == 200){
        // Populate occasions for both main section and global modal
        const occasionSelects = [
          select('#occasion'),           // Main reminder section
          select('#global-occasion')     // Global modal
        ].filter(select => select !== null); // Remove null elements

        occasionSelects.forEach(occasionSelect => {
          occasionSelect.innerHTML = '';
          
          const blankOption = document.createElement('option');
          blankOption.value = '';
          blankOption.textContent = '';
          occasionSelect.appendChild(blankOption);
          
          response.data.forEach(item => {
            const option = document.createElement('option');
            option.value = item.occasion;
            option.textContent = item.occasion;
            option.setAttribute('data-month', item.month);
            option.setAttribute('data-day', item.day);
            occasionSelect.appendChild(option);
          });
        });
      }
    })
    .catch((error) => console.error(error));

  }
  setTimeout(() => {
    if (window.occasionsFetch) {
      window.occasionsFetch();
    }
  }, 2000);


  window.relationshipsFetch = function(){
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(`${window.reminders.baseUrl}/relationships`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      let response = JSON.parse(result);
      if(response.meta.code == 200){
        // Populate relationships for both main section and global modal
        const recipientSelects = [
          select('#recipient'),           // Main reminder section
          select('#global-recipient')     // Global modal
        ].filter(select => select !== null); // Remove null elements

        recipientSelects.forEach(recipientSelect => {
          recipientSelect.innerHTML = '';
          
          const blankOption = document.createElement('option');
          blankOption.value = '';
          blankOption.textContent = '';
          recipientSelect.appendChild(blankOption);

          response.data.forEach(item => {
            const option = document.createElement('option');
            option.value = item;
            option.textContent = item;
            recipientSelect.appendChild(option);
          });
        });
      }
    })
    .catch((error) => console.error(error));
  }
  setTimeout(() => {
    if (window.relationshipsFetch) {
      window.relationshipsFetch();
    }
    if (window.reCallEventFun) {
      window.reCallEventFun();
    }
  }, 2000);


  const check_accepts_marketing = document.getElementById('accepts_marketing');
  const reminder = document.getElementById('reminder');

  if (check_accepts_marketing) {
    reminder.disabled = !check_accepts_marketing.checked;
    check_accepts_marketing.addEventListener('change', function() {
      if (check_accepts_marketing.checked) {
        reminder.disabled = false; 
      } else {
        reminder.disabled = true;
      }
      reminder.disabled = !check_accepts_marketing.checked;
    });
  }
});

// Customer tagging function (implemented in customer-tagger.liquid snippet)
// This is a fallback if the snippet is not included
if (!window.tagReminderCustomer) {
  window.tagReminderCustomer = function() {
    console.log('Customer tagging function not loaded. Make sure customer-tagger.liquid snippet is included.');
  };
}
